<template>
  <section>
    <Title :title-name="title.MessageDetail.titleName" :title-link="title.MessageDetail.titleLink" />
    <div class="select_service">
      <div class="container" style="margin-top: 14pt">
        <div class="row">
          <div class="col-2 sb_mobile sb_message"></div>
          <div class="col-10 font-weight-bold">
            <div>From: {{ pax.carrier_name }}</div>
            <div>Date: {{ moment(pax.std).format('YYYY-MM-DD') }}</div>
            <div v-if="newCmtpax && newCmtpax.status == 1">Subject: {{ newCmtpax.subject }}</div>
          </div>
          <div class="col-12" style="margin-top: 14pt">
            <h5 v-if="newCmtpax && newCmtpax.status == 1" class="font-weight-bold">
              <p class="email-mobile">Email:</p>
              <p>{{ newCmtpax.subject }}</p>
            </h5>
            <h5 v-else-if="newCmtpax && newCmtpax.status == 2" class="font-weight-bold">SMS:</h5>
            <div v-else class="font-weight-bold">Message:</div>

            <div>
              <div v-if="!msgId">
                <p>Dear Roelf ,</p>
                <p>
                  On behalf of {{ airline.name }}
                  I would like to apologize to you for the inconvenience.
                </p>
                <p>
                  It is our goal to provide exceptional service on every occasion, and I hope you will provide us with an
                  opportunity to restore your confidence.
                </p>
                <p>We apologize once again for this unfortunate event.</p>
                <p>Sincerely,</p>
              </div>
              <div v-if="newCmtpax && msgId" class="link-mobile" v-html="linkify(newCmtpax.content)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { linkify } from '@/utils/helper'
import Title from '@/components/Title/index'

export default {
  name: 'MessageDetail',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    },
    msgId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      pageTitle: 'Your Messages',
      newCmtpax: []
    }
  },
  computed: {
    ...mapGetters({
      Cmtpax: 'MessagesList/Cmtpax'
    })
  },
  mounted() {
    var newmMsgId = this.msgId
    this.$store.dispatch('MessagesList/getCmtpax').then((response) => {
      if (response) {
        this.newCmtpax = _.find(response, function (o) {
          return o.id == newmMsgId
        })
      }
    })
    this.$store.dispatch('MessagesList/updateMessage', newmMsgId)
  },
  methods: {
    linkify
  }
}
</script>

<style lang="scss">
.email-mobile {
  margin-bottom: 7pt;
}
.link-mobile a {
  font-size: inherit;
}
</style>
